import classNames from 'classnames';

import {assertAndContinue} from 'Asserts';

// Returns a classString
// For example, colSizeClassesFromProps(xs: 3, sm: 5, sm-offset: 1)
//     yields
// 'col-xs-3 col-sm-5 col-sm-offset-1'
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function colSizeClassesFromProps(props: any): string {
  const classes: Array<string> = [];
  ['xs', 'sm', 'md', 'lg'].forEach((size) => {
    // eslint-disable-next-line benchlint/no-in-operator
    if (size in props) {
      assertAndContinue(
        typeof props[size] === 'number',
        `Value for size key '${size}' was ${props[size]}; expected it to be a number`
      );
      classes.push(`col-${size}-${props[size]}`);
    }

    ['offset', 'push', 'pull'].forEach((mod) => {
      const modProp = `${size}-${mod}`;
      // eslint-disable-next-line benchlint/no-in-operator
      if (!(modProp in props)) {
        return;
      }
      const modValue = props[modProp];
      assertAndContinue(
        typeof modValue === 'number',
        `Value for ${mod} key '${modProp}' was ${modValue}; expected it to be a number`
      );
      classes.push(`col-${modProp}-${modValue}`);
    });
  });
  return classNames(classes);
}
